import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    RichTextField,
    ReferenceInput,
    AutocompleteInput,
    Link,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import { formStatuses, getStatuses, toSelectChoices } from "../helpers/strings";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { RichTextInput } from "ra-input-rich-text";
import { FormEditChildToolbar } from "../Components/FormEditChildToolbar";

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const FormStandardList = props => (
    <List title={"All Standards"} filters={listFilters} {...props} hasCreate>
        <Datagrid rowClick="show">
            <TextField source="name" />
            <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} />

            <TextField label="Form" source="form.name" />
        </Datagrid>
    </List>
);

const FormPreview = () => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return null;

    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Title</TableCell>
                    {/* <TableCell align="right">LP</TableCell> */}
                    {/* <TableCell align="right">CP</TableCell> */}
                    {/* <TableCell align="right">MSA</TableCell> */}
                </TableRow>
                </TableHead>
                <TableBody>
                {record.key_indicators.map((keyIndicator) => (<React.Fragment key={keyIndicator.name}>
                    <TableRow
                        sx={{ '& > *': {fontStyle: 'italic'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Link to={`/form-key-indicators/${keyIndicator.id}/show`}>
                                {keyIndicator.name}
                            </Link>
                        </TableCell>
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).lp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).cp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).msa}</TableCell> */}
                    </TableRow>
                    {keyIndicator.indicators.map((indicator) => (<React.Fragment key={indicator.name}>
                        <TableRow
                            sx={{ 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <Link to={`/form-indicators/${indicator.id}/show`}>
                                    {indicator.name}
                                </Link>
                            </TableCell>
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell> */}
                        </TableRow>
                    </React.Fragment>))}
                </React.Fragment>))}
                </TableBody>
            </Table>
        </TableContainer>
    </>);
};

export const FormStandardShowLayout = () => (
    <TabbedShowLayout>
        {/* <SimpleShowLayout> */}
        <Tab label="summary">
            <TextField source="name" />

            <TextField label="Form" source="form.name" />

            {/* sequence */}

            <RichTextField source="description"/>
            <RichTextField source="focus_areas"/>
            <RichTextField source="key_indicators_description"/>

        </Tab>
        <Tab label="Table of Contents">
            <em>Click on a title to navigate to that specific section.</em>
            <FormPreview/>
        </Tab>
    {/* </SimpleShowLayout> */}
    </TabbedShowLayout>
);

const FormStandardShow = props => (
    <Show {...props}>
        <FormStandardShowLayout/>
    </Show>
);

export const FormStandardEditForm = () => (
    <SimpleForm toolbar={<FormEditChildToolbar resource="form-baseline-requirements" deletable />}>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextInput source="name" isRequired fullWidth />
            </Grid>
            <Grid item xs={6}>
                <ReferenceInput source="form_id" perPage={-1} reference="forms">
                    <AutocompleteInput optionText="name" isRequired fullWidth />
                </ReferenceInput>
            </Grid>
        </Grid>

        {/* sequence */}
        {/* <NumberInput source="sequence" label="Order" /> */}

        <RichTextInput source="description"/>
        <RichTextInput source="focus_areas"/>
        <RichTextInput source="key_indicators_description"/>
    </SimpleForm>
);

const FormStandardEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <FormStandardEditForm/>
        {/*
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextInput source="name" isRequired fullWidth />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInput source="form_id" perPage={-1} reference="forms">
                        <AutocompleteInput optionText="name" isRequired fullWidth />
                    </ReferenceInput>
                </Grid>
            </Grid>

            {/* sequence *\/}
            {/* <NumberInput source="sequence" label="Order" /> *\/}

            <RichTextInput source="description"/>
            <RichTextInput source="focus_areas"/>
            <RichTextInput source="key_indicators_description"/>
        </SimpleForm>
        */}
    </Edit>
);

const FormStandardCreate = props => {
  return (
    <Create {...props} redirect="show">
        <FormStandardEditForm/>
        {/*
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextInput source="name" isRequired fullWidth />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInput source="form_id" perPage={-1} reference="forms">
                        <AutocompleteInput optionText="name" isRequired fullWidth />
                    </ReferenceInput>
                </Grid>
            </Grid>

            {/* sequence *\/}
            {/* <NumberInput source="sequence" label="Order" /> *\/}

            <RichTextInput source="description"/>
            <RichTextInput source="focus_areas"/>
            <RichTextInput source="key_indicators_description"/>
        </SimpleForm>
        */}
    </Create>
)
};

export {FormStandardList, FormStandardShow, FormStandardEdit, FormStandardCreate};
